module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_08-09800e0d23eae5ab0bd65e441e8b684e.jpg";